import { supabase } from './supabase';
import { Note } from '../types/note';

export const getNotes = async (leadId: string): Promise<Note[]> => {
  const { data, error } = await supabase
    .from('notes')
    .select('*, profiles(full_name)')
    .eq('lead_id', leadId)
    .order('created_at', { ascending: false });
  if (error) { console.error('Error fetching notes:', error); return []; }
  return (data || []).map((n: any) => ({
    ...n,
    author_name: n.profiles?.full_name,
  })) as Note[];
};

export const createNote = async (leadId: string, content: string, isImportant: boolean, createdBy?: string): Promise<Note | null> => {
  const { data, error } = await supabase
    .from('notes')
    .insert({ lead_id: leadId, content, is_important: isImportant, created_by: createdBy || null })
    .select()
    .single();
  if (error) { console.error('Error creating note:', error); return null; }
  return data as Note;
};

export const updateNote = async (id: string, updates: Partial<Pick<Note, 'content' | 'is_important'>>): Promise<boolean> => {
  const { error } = await supabase.from('notes').update(updates).eq('id', id);
  if (error) { console.error('Error updating note:', error); return false; }
  return true;
};

export const deleteNote = async (id: string): Promise<boolean> => {
  const { error } = await supabase.from('notes').delete().eq('id', id);
  if (error) { console.error('Error deleting note:', error); return false; }
  return true;
};

// Lädt die jeweils neueste Notiz für alle Leads auf einmal
export const getLatestNotesMap = async (): Promise<Map<string, string>> => {
  const { data, error } = await supabase
    .from('notes')
    .select('lead_id, content, created_at')
    .order('created_at', { ascending: false });

  if (error) { console.error('Error fetching latest notes:', error); return new Map(); }

  const map = new Map<string, string>();
  (data || []).forEach((n: any) => {
    if (!map.has(n.lead_id)) map.set(n.lead_id, n.content);
  });
  return map;
};
